/* Star ratings on product cards: reads approved reviews once (cached 10 min) and fills [data-card-stars] */
(function(){
  if(window.__mgStars) return; window.__mgStars=true;
  var st=document.createElement('style');
  st.textContent='.card-stars{display:flex;align-items:center;gap:6px;margin:4px 0 2px;font-size:12px;color:#4A4A4A}.card-stars .mg-stars{position:relative;display:inline-block;line-height:1;letter-spacing:1px;font-size:14px}.card-stars .mg-stars__bg{color:#E5E1DA}.card-stars .mg-stars__fg{position:absolute;left:0;top:0;width:var(--w);overflow:hidden;white-space:nowrap;color:#E8A93B}';
  document.head.appendChild(st);
  var data=null, S='★★★★★';
  var preview=(window.Shopify&&Shopify.theme&&Shopify.theme.role!=='main')?('&preview_theme_id='+Shopify.theme.id):'';
  var KEY='mgStars'+preview;
  function fill(){
    if(!data) return;
    document.querySelectorAll('[data-card-stars]:not([data-done])').forEach(function(el){
      el.setAttribute('data-done','1');
      var d=data[el.getAttribute('data-card-stars')]; if(!d) return;
      var avg=d[0]/d[1];
      el.innerHTML='<span class="mg-stars" style="--w:'+(avg*20)+'%"><span class="mg-stars__bg">'+S+'</span><span class="mg-stars__fg">'+S+'</span></span><span>('+d[1]+')</span>';
      el.setAttribute('aria-label','Rated '+avg.toFixed(1)+' out of 5 from '+d[1]+' reviews');
      el.hidden=false;
    });
  }
  function load(){
    var c=null; try{c=JSON.parse(sessionStorage.getItem(KEY)||'null');}catch(e){}
    if(c&&Date.now()-c.t<600000){data=c.d;fill();return;}
    fetch('/pages/reviews?view=stars-json'+preview,{credentials:'same-origin'}).then(function(r){return r.text();}).then(function(t){
      var arr=JSON.parse(t.trim()||'[]'), m={};
      arr.forEach(function(p){var k=String(p[0]); m[k]=m[k]||[0,0]; m[k][0]+=p[1]; m[k][1]+=1;});
      data=m; try{sessionStorage.setItem(KEY,JSON.stringify({t:Date.now(),d:m}));}catch(e){}
      fill();
    }).catch(function(){});
  }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',load); else load();
  new MutationObserver(function(){fill();}).observe(document.documentElement,{childList:true,subtree:true});
})();
